/* eslint-disable no-underscore-dangle */
import { APP_NAME } from '../const';

const SETUP = `${APP_NAME}/mz/SETUP`;
const SETUP_RESOURCE = `${APP_NAME}/mz/SETUP_RESOURCE`;
export const setup = (pageType) => ({ type: SETUP, pageType });
export const setupResource = (resource, pageType) => ({ type: SETUP_RESOURCE, resource, pageType });

const EMIT = `${APP_NAME}/mz/EMIT`;
const emit = (mzAction, data) => ({ type: EMIT, payload: { mzAction, data } });
export const emitPageView = (data) => emit('PAGE_VIEW', data);
export const emitClick = (moduleType, moduleId) => emit('CLICK', { module: { type: moduleType, id: moduleId } });
export const emitReview = (data) => emit('REVIEW', data);
export const emitRating = (data) => emit('RATING', data);

export function createMiddleware(win) {
  return () => (next) => (action) => {
    const { _mz, _mze } = win;
    const { type, payload = {} } = action;
    win.TES = win.TES || {}; // eslint-disable-line no-param-reassign
    if (type === SETUP) {
      win.TES.pageMetadata = { // eslint-disable-line no-param-reassign
        type: action.pageType,
        section: 'resources',
        subSection: 'user-dashboard',
      };

      const readCookie = (k) => (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2];
      const userId = readCookie('TESCookieUser');
      win.TES.userMetadata = { // eslint-disable-line no-param-reassign
        id: userId,
      };
    }
    if (type === SETUP_RESOURCE) {
      win.TES.pageMetadata = { // eslint-disable-line no-param-reassign
        id: action.resource._id,
        authorId: action.resource.authorId,
        resourceLicenceType: action.resource.licence,
        type: action.pageType,
        section: 'resources',
        subSection: 'user-dashboard',
      };
    }
    if (!_mz || !_mze) return next(action);

    _mz.pageMetadata = win.TES.pageMetadata || _mz.pageMetadata;
    _mz.userMetadata = win.TES.userMetadata || _mz.userMetadata;

    switch (type) {
      case EMIT: {
        const { mzAction, data } = payload;
        _mz.emit(_mze[mzAction], data);
        break;
      }
      default:
    }
    return next(action);
  };
}
